// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"c6722343","167":"877776ae","215":"8dd0d4cf","221":"6f61fbf8","224":"fbd6caa1","270":"c47273a5","345":"3030e57c","409":"01c435c1","535":"4851f7d6","608":"cd51f350","621":"131594ff","641":"873a8803","843":"763c9647","896":"2160056f"}[chunkId] + ".chunk.js";
};